export function appendSchemaToHead(schema: object, id: string) {
    const schemaId = id;
    let script = document.getElementById(schemaId) as HTMLScriptElement;
  
    const jsonSchema = JSON.stringify(schema);
  
    if (script) {
      // If the script already exists, update its content
      script.innerHTML = jsonSchema;
    } else {
      // If the script doesn't exist, create a new one
      script = document.createElement('script');
      script.id = schemaId;
      script.type = 'application/ld+json';
      script.innerHTML = jsonSchema;
  
      document.head.appendChild(script);
    }
  }